var _defs, _circle, _path, _circle2, _circle3, _circle4, _circle5, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t  .cls-1 {\r\n\t    fill: #fff1e6;\r\n\t  }\r\n\t  \r\n\t  .cls-2 {\r\n\t    fill: none;\r\n\t\tstroke: #f7931e;\r\n\t\tstroke-miterlimit: 10;\r\n\t\tstroke-width: 2px;\r\n\t  }\r\n\t  \r\n\t  .cls-3 {\r\n\t    fill: #f7931e;\r\n\t  }\r\n\t"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24,
    cy: 24,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.92,15.57c4.5,0,4.13-1.5,6.75-1.5,3,0,6,3.82,7.13,8.25S38.92,34,35.92,34c-2.62,0-7.5-4.5-12-4.5-5.25,0-8.25,4.5-12,4.5C10,34,9.13,30.22,9.67,25.32s3.14-10.87,7.13-11.25C18.88,13.87,20.17,15.57,23.92,15.57Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 31.42,
    cy: 19.7,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.3,
    cy: 19.7,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.3,
    cy: 23.82,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 31.42,
    cy: 23.82,
    r: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.33,
    y: 17.82,
    width: 1.69,
    height: 7.87,
    rx: 0.84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.51,
    y: 18.01,
    width: 1.69,
    height: 7.87,
    rx: 0.84,
    transform: "translate(39.3 4.59) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIcon);
export default __webpack_public_path__ + "static/media/game-icon.d5923d13b05305905dfde386b313f833.svg";
export { ForwardRef as ReactComponent };